import React from 'react'
import classNames from 'classnames'

import { Modal, ModalHeader, ModalBody, Text } from '@evertel/web/ui'
import { APIDataDocumentSchema, APIDataDocumentSchemaCategory } from '@evertel/types'

interface CategoryTemplatesModalProps {
    visible: boolean
    category?: APIDataDocumentSchemaCategory
    onClose: () => void
}

const CategoryTemplatesModal: React.FC<CategoryTemplatesModalProps> = ({
    visible,
    category,
    onClose
}) => {

    // the include already carries disabled templates, so no extra fetch is needed to show them.
    // No early return on !category: the Modal must stay mounted across close so it can animate
    // out and hand focus back to the button that opened it
    const templates = category?.documentSchemas || []
    const enabled = templates.filter(t => t.isEnabled)
    const disabled = templates.filter(t => !t.isEnabled)

    return (
        <Modal
            visible={visible}
            onClose={onClose}
            size="md"
            alignment="center">
            <ModalHeader
                title={`${enabled.length} templates in ${category?.name}:`}
            />
            <ModalBody>
                {(!enabled.length) ?
                    <Text color="muted">
                        This category has no templates yet.
                    </Text>
                    :
                    <TemplatesList templates={enabled} />
                }
                {(!!disabled.length) && (
                    <>
                        <Text
                            tag="h6"
                            color="muted"
                            className="mt-4 mb-2">
                            Disabled ({disabled.length})
                        </Text>
                        <TemplatesList templates={disabled} muted />
                    </>
                )}
            </ModalBody>
        </Modal>
    )
}

interface TemplatesListProps {
    templates: APIDataDocumentSchema[]
    muted?: boolean
}

// fills the first column before flowing into the second
const TemplatesList: React.FC<TemplatesListProps> = ({ templates, muted }) => (
    <ul className={classNames('category-templates-list mb-0', { 'text-muted': muted })}>
        {templates.map((template) => (
            <li key={template.id}>
                {template.name}
            </li>
        ))}
    </ul>
)

export { CategoryTemplatesModal }
